<template>
  <div class="sf-page">
    <top-header narrow
                v-bind:title="$t('information')">
      <v-btn class="sf-back-btn"
             exact
             slot="left-button"
             text
             v-bind:to="{ name: 'administration-dashboard' }">
        <v-icon left>ti-arrow-left</v-icon>
        {{ $t('back') }}
      </v-btn>
      <v-btn color="primary"
             outlined
             exact
             slot="right-button"
             v-on:click="edit = true"
             v-if="!edit">
        <v-icon left>ti-pencil</v-icon>
        {{ $t('edit') }}
      </v-btn>
      <v-btn color="primary"
             depressed
             exact
             slot="right-button"
             v-on:click="update"
             v-else>
        <v-icon left>ti-check</v-icon>
        {{ $t('save') }}
      </v-btn>
    </top-header>
    <div class="sf-container sf-container--narrow">
      <v-card class="sf-card"
              flat
              v-if="!edit && textSnippet != null">
        <v-card-text class="sf-card__body">
          <p class="mb-0" v-html="text"></p>
        </v-card-text>
      </v-card>
      <div v-else-if="textSnippet != null">
        <v-textarea auto-grow
                    hide-details="auto"
                    outlined
                    rows="12"
                    v-bind:label="$t('text')"
                    v-model="textSnippet.text" />
      </div>
    </div>
  </div>
</template>

<script>
  import TopHeader from '@/components/common/TopHeader'

  export default {
    components: {
      TopHeader
    },
    computed: {
      text() {
        if (this.textSnippet == null) {
          return ''
        }

        if (this.textSnippet.text == null) {
          return ''
        }

        return this.textSnippet.text.replace(/(?:\r\n|\r|\n)/g, '<br />')
      }
    },
    async created() {
      await this.$store.dispatch('loadInfoTextSnippet')

      this.textSnippet = Object.assign({}, this.$store.getters.infoTextSnippet)
    },
    data: () => ({
      textSnippet: null,
      edit: false
    }),
    name: 'Info',
    methods: {
      async update() {
        await this.$store.dispatch('updateInfoTextSnippet', { textSnippet: this.textSnippet})

        this.edit = false
      }
    }
  }
</script>

<i18n>
  {
    "de": {
      "information": "Informationen",
      "edit": "Bearbeiten",
      "save": "Speichern",
      "text": "Bitte geben Sie einen Text ein…",
      "back": "Zurück"
    },
    "en": {
      "information": "Information",
      "edit": "Edit",
      "save": "Save",
      "text": "Please enter some text",
      "back": "Back"
    }
  }
</i18n>